import React, { Component } from "react";
import _ from "lodash";

class TableBody extends Component {
  renderCell = (item, column) => {
    if (column.content) return column.content(item);
    return _.get(item, column.key);
  };

  createKey = (item, column) => {
    return item.id + "_" + column.key;
  };

  render() {
    const { data, columns } = this.props;

    return (
      <tbody>
        {data.map(item => (
          <tr key={item.id} className="row">
            {columns.map(column => (
              <td
                key={this.createKey(item, column)}
                className={column.className}
              >
                {this.renderCell(item, column)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }
}

export default TableBody;



// WEBPACK FOOTER //
// ./src/components/common/table/tableBody.jsx